export * from './app-aside.component';



// WEBPACK FOOTER //
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/components/app-aside/index.ts